import {
  IAnalyticsRepository,
  IAnalyticsRepositoryParams,
  IDeductionsByAgingBracketsRepositoryResponse,
} from "@/core/repositories/analytics";

export class GetDeductionsByAgingBracketsUseCase {
  constructor(private readonly repo: IAnalyticsRepository) {}

  async execute(params: IAnalyticsRepositoryParams): Promise<IDeductionsByAgingBracketsRepositoryResponse> {
    return this.repo.getDeductionsByAgingBrackets(params);
  }
}
